import { useEffect } from 'react';

import { useGeolocation } from 'state/geolocation';

export const useUserLocationTracker = () => {
  const { isPermissionGranted, loadCurrentPosition } = useGeolocation();

  useEffect(() => {
    const listener = () => {
      const visibilityState = document.visibilityState === 'visible';

      if (isPermissionGranted && visibilityState) {
        loadCurrentPosition();
      }
    };

    document.addEventListener('visibilitychange', listener);

    return () => document.removeEventListener('visibilitychange', listener, true);
  }, [isPermissionGranted, loadCurrentPosition, document.visibilityState]);
};
